import { ReactElement, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLogDailyInteractionEventFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";
import { appInsightsLogger } from "core/monitoring/AppInsights";

export const DailyActiveUsageLogger = (): ReactElement => {
  const location = useLocation();
  const { trigger } = useLogDailyInteractionEventFunctionRequest();

  useEffect(() => {
    trackEvents(EventNames.DAILY_ACTIVE_USAGE);
    trigger({ body: {} }).catch((err) => {
      appInsightsLogger.error("dau_log_failed", err);
    });
  }, [location.pathname, trigger]);

  return <></>;
};
